import { graphql } from 'graphql-setup'

export const ALL_TERMINAL_ENTRIES = graphql(`
  query AllTerminalEntries(
    $user: ID!
    $last: Int
    $checkInGte: DateTime
    $checkInLt: DateTime
  ) {
    allTimeEntries(
      user: $user
      last: $last
      datetimeStart_Gte: $checkInGte
      datetimeStart_Lt: $checkInLt
      fromTerminal: true
    ) {
      edges {
        node {
          id
          datetimeStart
          datetimeEnd
          totalWork
          pause
          overtime
          user {
            id
          }
        }
      }
    }
    isOnTerminalNetwork
    isWorking
    user(id: $user) {
      id
      fullName
      salaryWorkTime(moduleConfigName: "Terminal") {
        id
        name
        dailyWorkLimit
        pauseDuration
      }
    }
    allAbsences(
      user: $user
      datetimeEnd_Gte: $checkInGte
      datetimeStart_Lt: $checkInLt
    ) {
      edges {
        node {
          id
          absenceType {
            id
            name
            color
          }
          datetimeStart
          datetimeEnd
          reason
        }
      }
    }
  }
`)

export const TODAYS_TERMINAL_ENTRIES = graphql(`
  query TodaysTerminalEntries($user: ID!) {
    todaysTimeEntries(user: $user, fromTerminal: true) {
      edges {
        node {
          id
          datetimeStart
          datetimeEnd
          totalWorkTime
        }
      }
    }
    todaysTimeEntriesTotalWorkTime(onlyTerminal: true)
    isOnTerminalNetwork
    isWorking
  }
`)

export const ALL_TERMINALS = graphql(`
  query AllTerminals {
    allTerminals {
      edges {
        node {
          id
          name
          ip
          ipFilterRange
        }
      }
    }
  }
`)
